module.exports = __webpack_public_path__ + "img/10.8108b01b.png";